import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { BookingResponse } from 'app/typings/core/admin/bookings/booking';
import type { CreateBookingRefundForm } from 'app/typings/core/admin/bookings/bookingRefundForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type CreateBookingRefundParams = {
  code: string;
  payload: CreateBookingRefundForm;
};

export function useCreateBookingRefund() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ code, payload }: CreateBookingRefundParams) =>
      apiMutation(
        'POST',
        { path: ENDPOINTS.createBookingRefund, params: { bookingCode: code } },
        payload
      ) as Promise<BookingResponse>,
    onSuccess: (_, variables) => {
      message.success('Booking refund successfully created');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.booking, { code: variables.code }],
      });

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.bookingRefund, { code: variables.code }],
      });
    },
    onError: () => {
      message.error('Failed to create booking refund');
    },
  });
}
